import React, { useEffect, useRef, useState } from "react";
import * as S from "./style";
import { ArtTop10CardItem } from "components";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

interface Props {
  data?: ArtTop10CardItemProps[];
  dataTitle?: DataTitleProps;
}

interface ArtTop10CardItemProps {
  id: number;
  authorName: string;
  productName: string;
  exhibitionDestination: string;
  price: string;
  tradeDay: string;
  rank: number;
}

interface DataTitleProps {
  endDate?: string;
  startDate?: string;
  title1?: string;
  title2?: string;
}

function ArtTop10({ data = [], dataTitle = {} }: Props) {
  const [items, setItems] = useState<ArtTop10CardItemProps[]>([]);
  const listRef = useRef<HTMLDivElement>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const currentIndexRef = useRef(0);
  const [flippedHistory, setFlippedHistory] = useState<number>(-1);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (data.length === 0) return;
    setItems(data);
  }, [data]);

  let visibleItems = showAll ? items : data.slice(0, 4);

  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (visibleItems.length === 0) return;

    intervalRef.current = setInterval(() => {
      const index = currentIndexRef.current % visibleItems.length;
      setFlippedHistory(index);
      currentIndexRef.current = index + 1;
    }, 1800);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [visibleItems, data]);

  useEffect(() => {
    if (!showAll) {
      currentIndexRef.current = 0;
    }
  }, [showAll]);

  return (
    <S.ArtTop10>
      <div className="title">
        <span className="sub">{dataTitle?.title1 ?? ""}</span>
        <span className="main">{dataTitle?.title2 ?? ""}</span>
      </div>
      <div className="list" ref={listRef}>
        {visibleItems.map((card, idx: number) => (
          <ArtTop10CardItem
            key={card.id ?? idx}
            flipped={flippedHistory === idx}
            data={card}
          />
        ))}
      </div>
      <div className="more-btn" onClick={() => setShowAll(!showAll)}>
        {showAll ? (
          <FiChevronUp size={30} color="#C0C0C0" />
        ) : (
          <FiChevronDown size={30} color="#C0C0C0" />
        )}
      </div>
    </S.ArtTop10>
  );
}

export default ArtTop10;
